export default "__VITE_ASSET__DpaYStUG__"